import { useContext, useEffect, useState } from 'react';
import { Estates } from '~js/React/Enums';
import { ForSaleBrokerContext } from '~js/React/pages/Context/ForSaleBrokerContext';

const CreateSearchProfileBtn = ({
  setShowHideModalFunction,
  isScrollOverHeadline = false,
  sessionId,
}: {
  setShowHideModalFunction(val: boolean): void;
  sessionId?: string;
  isScrollOverHeadline?: boolean;
}): JSX.Element => {
  const { isAuthorizedBroker, setShowErrorForSale } =
    useContext(ForSaleBrokerContext);
  const [bottomPos, setBottomPos] = useState<string>('bottom-[-4rem]');

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || window.pageYOffset;
      if (window.innerWidth < 1024 && scrollPosition > 450) {
        if (bottomPos != 'bottom-4') {
          setBottomPos('bottom-4');
        } else {
          setBottomPos('bottom-[-4rem]');
        }
      } else {
        setBottomPos('bottom-[-4rem]');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div
      className={`${
        isScrollOverHeadline ? 'xxl:bottom-6' : 'xxl:bottom-8'
      } ${bottomPos} mdplus:bottom-4 lg:sticky fixed left-0 z-[998] w-full lg:w-1/4 lg:min-w-[25.8rem] transition-all duration-75`}
    >
      <button
        className="px-8 py-3 text-center rounded-3xl bg-blue700/70 lg:bg-blue700/80 hover:bg-blue700 transition-all duration-200 text-white mx-auto hover:cursor-pointer focus:outline-none button flex items-center"
        type="button"
        onClick={() => {
          isAuthorizedBroker && sessionId != null
            ? setShowErrorForSale(true)
            : setShowHideModalFunction(true);
        }}
      >
        {Estates.CreateSearchProfile}
        <img
          width={24}
          height={24}
          className="w-6 ml-2"
          src="/Images/Icons/monitoring_white.svg"
          alt="Ikon skapa bevakning"
        />
      </button>
    </div>
  );
};
export default CreateSearchProfileBtn;
